import { ADD_SIMPANAN_POKOK } from "redux/constants/admin/masterdata/constants";

const initialState = {
    loading: false,
    loadingAction: false,
    isModalAction: false,
    submitSuccess: false,

    dataSimpananPokok: {
        data: [],
        count: 0,
    },

    queryKey: "",
    selectedIds: [],

    cache: {},
    loadingByKey: {},
};

const simpananPokokReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SIMPANAN_POKOK.LOADING_DATA_SIMPANAN_POKOK_SUCCESS:
            return {
                ...state,
                loading: action.load,
            };

        case ADD_SIMPANAN_POKOK.LOADING_ACTION_SIMPANAN_POKOK:
            return {
                ...state,
                loadingAction: action.load,
            };

        case ADD_SIMPANAN_POKOK.IS_MODAL_ACTION_SIMPANAN_POKOK:
            return {
                ...state,
                isModalAction: action.load,
            };

        case ADD_SIMPANAN_POKOK.GET_DATA_SIMPANAN_POKOK_SUCCESS:
            return {
                ...state,
                dataSimpananPokok: action.data,
            };

        case ADD_SIMPANAN_POKOK.SIMPANAN_POKOK_SUCCESS:
            return {
                ...state,
                submitSuccess: true,
            };

        case ADD_SIMPANAN_POKOK.SIMPANAN_POKOK_RESET:
            return {
                ...state,
                submitSuccess: false,
            };

        case ADD_SIMPANAN_POKOK.SET_QUERY_KEY:
            return {
                ...state,
                queryKey: action.key,
            };

        case ADD_SIMPANAN_POKOK.ADD_SELECTED_IDS:
            return {
                ...state,
                selectedIds: Array.from(
                    new Set([...state.selectedIds, ...action.ids])
                ),
            };

        case ADD_SIMPANAN_POKOK.REMOVE_SELECTED_IDS:
            return {
                ...state,
                selectedIds: state.selectedIds.filter(
                    (id) => !action.ids.includes(id)
                ),
            };

        case ADD_SIMPANAN_POKOK.CLEAR_SELECTED_IDS:
            return {
                ...state,
                selectedIds: [],
            };

        case ADD_SIMPANAN_POKOK.SET_CACHE_ENTRY:
            return {
                ...state,
                cache: {
                    ...state.cache,
                    [action.key]: action.data,
                },
            };

        case ADD_SIMPANAN_POKOK.SET_LOADING_FOR_KEY:
            return {
                ...state,
                loadingByKey: {
                    ...state.loadingByKey,
                    [action.key]: action.loading,
                },
            };

        case ADD_SIMPANAN_POKOK.UPDATE_CACHE_ITEMS: {
            const updatedCache = { ...state.cache };

            Object.keys(updatedCache).forEach((key) => {
                const entry = updatedCache[key];
                if (!entry?.data) return;

                updatedCache[key] = {
                    ...entry,
                    data: entry.data.map((item) =>
                        action.changesById[item.id]
                            ? { ...item, ...action.changesById[item.id] }
                            : item
                    ),
                };
            });

            return {
                ...state,
                cache: updatedCache,
            };
        }

        default:
            return state;
    }
};

export default simpananPokokReducer;
